module.exports = __webpack_public_path__ + "img/tutorial05.71d28fee.svg";